export default "__VITE_ASSET__COejVwYi__"